// Import HTTP client
import {
  createWithdrawalMethodService,
  getWithdrawalMethodsService,
  deleteWithdrawalMethodService,
  withdrawalRequestService,
  approveCancelWithdrawalService
} from '@/services/withdrawalService'

/** mutation types */
const set_withdrawalMethods = 'set_withdrawalMethods'
const set_currentWithdrawalMethod = 'set_currentWithdrawalMethod'

/** state */
const getDefaultState = () => {
  return {
    withdrawalMethods: [],
    currentWithdrawalMethod: {}
  }
}
const state = getDefaultState()

/** getters */
const getters = {
  withdrawalMethods: () => state.withdrawalMethods
}

/** mutations */
const mutations = {
  [set_withdrawalMethods] (state, data) {
    state.withdrawalMethods = data
  },
  [set_currentWithdrawalMethod] (state, data) {
    state.currentWithdrawalMethod = data
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  resetWithdrawalState ({ commit }) {
    commit('resetState')
  },
  createWithdrawalMethod: ({ commit }, payload) => {
    return createWithdrawalMethodService(payload).then((response) => {
      commit('set_currentWithdrawalMethod', response.data.data.details)
    })
  },

  getWithdrawalMethods: ({ commit }, payload) => {
    return getWithdrawalMethodsService(payload).then((response) => {
      commit('set_withdrawalMethods', response.data.data.items)
    })
  },
  deleteWithdrawalMethod: ({ commit }, payload) => {
    return deleteWithdrawalMethodService(payload).then((res) => {})
  },
  initiateWithdrawalRequest: ({ commit }, payload) => {
    return withdrawalRequestService(payload).then((res) => {})
  },
  approveCancelWithdrawal: ({ commit }, payload) => {
    return approveCancelWithdrawalService(payload).then((res) => {})
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
